import CodingConstants from 'constants/CodingConstants'
import ExcerptMathUtil from 'utils/ExcerptMathUtil'
var _ = require('underscore');

const DEFAULT_STYLE = CodingConstants.NORMAL;

class SentenceClass {
  constructor(text, start, excerptId, excerptIds, codeIds = []) {
    this.text = text;
    this.start = start;
    this.end = start + text.length;
    this.excerptId = excerptId;
    this.excerptIds = excerptIds || [];
  }

  _createSelects(select)
  {
    var original = {
      start: this.start,
      end: this.end,
      label: DEFAULT_STYLE
    };

    if ( !select ) return [original];

    var selectResults = ExcerptMathUtil.subtract(original, [{
      start: select.start,
      end: select.end,
      label: CodingConstants.SELECTED
    }]);

    return selectResults;
  }

  _createElements(originalElement, primeCode, excerpts)
  {
    var primifiedExcerpts = (excerpts || []).
      filter((excerpt)=>
      // inside excerpt and has to have codings
        excerpt.end > this.start && excerpt.start < this.end && !!excerpt.codings && excerpt.codings.length > 0
      ).map((excerpt) =>{
        // Extract all unique code_ids from the excerpt's codings
        const codeIds = _.uniq(excerpt.codings.map(coding => coding.code_id));
        // Check if any of the codings have the prime code
        const containsPrime = primeCode ? codeIds.includes(Number(primeCode)) : false;
        return {
          start: excerpt.start,
          end: excerpt.end,
          prime: containsPrime,
          codeIds
        }
      });

    var unionedExcerpts = ExcerptMathUtil.union(primifiedExcerpts).map((excerpt) =>{
      return {
        start: excerpt.start,
        end: excerpt.end,
        label: excerpt.prime ? CodingConstants.SUPERCODED: CodingConstants.CODED,
        codeIds: excerpt.codeIds
      }
    });

    var excerptMathResult = ExcerptMathUtil.subtract(originalElement, unionedExcerpts);

    return excerptMathResult.map((phrase)=>{
      return {
        style:phrase.label,
        text:this.text.substring(phrase.start - this.start, phrase.end - this.start),
        start: phrase.start,
        end: phrase.end,
        codeIds: phrase.codeIds
      }
    })
  }

  _createSelectedElements(primeCode, select, excerpts){
    var selectedResults = this._createSelects(select);

    return selectedResults.map((selectUnit)=>{
      return {
        style: selectUnit.label,
        elements: this._createElements({
            start: selectUnit.start,
            end: selectUnit.end,
            label: CodingConstants.UNCODED
          }, primeCode, excerpts
        )
      }
    })
  }

  getCodedFormat(primeCode, select, excerpts){
    return {
      start:this.start,
      end: this.end,
      excerptId: this.excerptId,
      excerptIds: this.excerptIds,
      selectElements: this._createSelectedElements(primeCode, select, excerpts)
    }
  }
}

export default SentenceClass;
